import React from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import moment from 'moment';

var pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";

const CustomMarker = (props) => {
    // console.log('CustomMarker...', props)
    const [state, setState] = React.useState({
        showInfoWindow: false,
        stopHide: false,
        isActive: false
    })
    const timeoutRef = React.useRef()
    const { highlightedStop, activeMarker, jobsite, updateActiveMarker } = props;

    React.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    React.useEffect(() => {
        if (props.activeMarker && props.activeMarker._id && props.activeMarker._id === props.jobsite._id) {
            setState({...state, isActive: true })
        }
    }, [props])
 
    const handleMouseOver = e => {
        setState(prevState => ({
            ...prevState,
            showInfoWindow: true
        }))
    };

    const handleMouseExit = e => {
        if (state.isActive && !props.hideInfoWindowOnActiveItem) {
            // Don't close if this is the active item
        } else {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        
            timeoutRef.current = setTimeout(() => {
                if (!state.stopHide) {
                    setState(prevState => ({
                        ...prevState,
                        showInfoWindow: false
                    }));
                }
            }, 2000);
        }
    };

    const handleClick = (e) => {
        console.log('Click on this marker!!', props.jobsite)
        setState(prevState => ({
            ...prevState,
            showInfoWindow: true,
            stopHide: true
        }));
        if (props.updateActiveMarker) {
            props.updateActiveMarker(props.jobsite)
        }
    }
    let jobSiteId = props?.jobsite?._id
    let ourPos = props.position
    if (!ourPos.lat || !ourPos.lng) {
       if (props?.jobsite?.location?.coordinates?.length) {
        ourPos.lat = props.jobsite.location.coordinates[1]
        ourPos.lng = props.jobsite.location.coordinates[0]
       }
    }

    if (ourPos && ourPos.lat && ourPos.lng) {
        const lat = Number(ourPos.lat)
        const lng = Number(ourPos.lng)
        let theColor = props.color
        // console.log('80...theColor', theColor)
        if (props.jobsite && props.jobsite.color) theColor = props.jobsite.color
        let scale = 6
        let strokeColor = 'black'

        let activeMarkerId = props?.activeMarker?._id
   
        
        // Don't show icon if this is the active marker (will be replaced by default marker)
        if (activeMarkerId === jobSiteId) return null

        let siteName = `${props.jobsite.name}`
        
        // Check if this marker should show an order number
        const shouldShowOrderNumber = props.showOrderNumbers && props.jobsite?.orderNumber;
        
        // Default marker icon
        let theIcon = {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: shouldShowOrderNumber ? 8 : scale,
            fillColor: theColor,
            fillOpacity: 0.8,
            strokeWeight: 2,
            rotation: 0,
            strokeColor: strokeColor
        }
        if (highlightedStop === jobSiteId && !activeMarkerId) {
            theIcon = {
              path: pinSVGFilled,
              anchor: new window.google.maps.Point(12,17),
              fillOpacity: 1,
              fillColor: theColor,
              strokeWeight: 3,
              strokeColor: "white", // White stroke for highlighted crew stops
              scale: 2,
              labelOrigin: new window.google.maps.Point(12,9),
            };
          }

          if (shouldShowOrderNumber && highlightedStop !== jobSiteId) {
            theIcon = {
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 12,
              fillColor: theColor,
              fillOpacity: 0.9,
              strokeWeight: 2,
              strokeColor: "white",
            };
          }
        
        let clientName = (props.jobsite && props.jobsite.clientName) ? props.jobsite.clientName : 'CLIENT'
        let clientId = ''
        if (props.jobsite && props.jobsite.client) {
            clientId = props.jobsite.client
            if (props.jobsite.client._id) {
                clientId = props.jobsite.client._id
            }
        }


        // Handle highlighted markers - use pin shape to really stand out
        if (props?.highlightedSite?._id === jobSiteId) {
            theIcon = {
                path: pinSVGFilled,
                anchor: new window.google.maps.Point(12, 22), // Anchor at bottom of pin
                fillOpacity: 1,
                fillColor: "#2196f3",      // Bright blue for highlighted
                strokeWeight: 3,
                strokeColor: "white",      // White stroke for contrast
                scale: 2.5,                // Large size to stand out
                labelOrigin: new window.google.maps.Point(12, 9),
            };
        }

        // Create label for order number
        let markerLabel = undefined;
        if (shouldShowOrderNumber) {  // Remove the check for activeMarkerId
          markerLabel = {
            text: props.jobsite.orderNumber.toString(),
            color: "white",
            fontSize: "14px",
            fontWeight: "bold"
          };
        }
        // console.log('150 Marker Icon', theIcon, props)
        return (
            <Marker 
                position={{ lat, lng }} 
                icon={theIcon}
                onClick={handleClick}
                onMouseOver={handleMouseOver}
                title={siteName}
                onMouseOut={handleMouseExit}
                label={markerLabel}
            />
        );
    } else {
        console.log('invalid marker...', props)
        return null
    }
}

export default React.memo(CustomMarker)
